import React from 'react';
import { Button } from '@mui/material';
import { motion } from 'framer-motion';

const AnalysisButton = ({ agreementType, contractText, onSuccess }) => {
  const handleClick = () => {
    if (agreementType && contractText) {
      onSuccess();
    }
  };

  return (
    <motion.div initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.4, delay: 0.2 }}>
      <Button
        variant="contained"
        onClick={handleClick}
        disabled={!agreementType || !contractText}
        sx={{
          mb: 2,
          background: 'linear-gradient(45deg, #1976d2, #7b1fa2)',
          '&:hover': { background: 'linear-gradient(45deg, #1565c0, #6a1b9a)' },
          '&.Mui-disabled': { background: 'grey.400', color: 'grey.600' },
          borderRadius: 2,
        }}
      >
        Start Analysis
      </Button>
    </motion.div>
  );
};

export default AnalysisButton;